import { makeStyles } from '@fluentui/react-components';

export const usePaginatorStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
});
